.itemSection {
  &[data-position="left"] {
    width: 15px;
  }
}
